/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'members',
    //     title: 'Membership',
    //     type: 'group',
    //     icon: 'heroicons_outline:users',
    //     children: [
    //         {
    //             title: 'Individual Members',
    //             id: 'individual-members',
    //             link: '/members/individual',
    //             type: 'basic',
    //             icon: 'heroicons_outline:users',
    //         },
    //         {
    //             title: 'Sustaining Members',
    //             id: 'company-members',
    //             link: '/members/company',
    //             type: 'basic',
    //             icon: 'heroicons_outline:users',
    //         },
    //         {
    //             title: 'Committee',
    //             id: 'committee',
    //             link: '/committee',
    //             type: 'basic',
    //             icon: 'heroicons_outline:user-group',
    //         },
    //         {
    //             title: 'Chapters',
    //             id: 'chapters',
    //             link: '/chapters',
    //             type: 'basic',
    //             icon: 'heroicons_outline:book-open',
    //         },
    //         {
    //             id: 'reports',
    //             title: 'Reports',
    //             type: 'basic',
    //             icon: 'heroicons_outline:chart-bar',
    //             link: '/reports',
    //         }
    //     ],
    // },
    {
        id: 'certification',
        title: 'Professional Certification',
        type: 'group',
        icon: 'mat_outline:card_membership',
        children: [
            {
                title: 'Certificates',
                id: 'certification',
                link: '/certification',
                type: 'basic',
                icon: 'mat_outline:approval',
            },
            {
                title: 'Classes',
                id: 'class',
                link: '/classes',
                type: 'basic',
                icon: 'mat_outline:class',
            },
            {
                title: 'Schools',
                id: 'school',
                link: '/schools',
                type: 'basic',
                icon: 'mat_outline:school',
            },
            {
                title: 'Reports',
                id: 'report',
                link: '/reports-certificate',
                type: 'basic',
                icon: 'mat_outline:assessment',
            },
            {
                id: 'maintenance',
                title: 'Maintenance',
                type: 'basic',
                icon: 'heroicons_outline:cog',
                link: '/maintenance',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'members',
    //     title: 'Membership',
    //     type: 'group',
    //     icon: 'heroicons_outline:users',
    //     // link: '/members'
    //     children: [
    //         {
    //             title: 'Members',
    //             id: 'individual-members',
    //             link: '/members/individual',
    //             type: 'basic',
    //             icon: 'heroicons_outline:users',
    //         },
    //         {
    //             title: 'Sustaining Members',
    //             id: 'company-members',
    //             link: '/members/company',
    //             type: 'basic',
    //             icon: 'heroicons_outline:users',
    //         },
    //         {
    //             title: 'Committee',
    //             id: 'committee',
    //             link: '/committee',
    //             type: 'basic',
    //             icon: 'heroicons_outline:user-group',
    //         },
    //         {
    //             title: 'Chapters',
    //             id: 'chapters',
    //             link: '/chapters',
    //             type: 'basic',
    //             icon: 'heroicons_outline:book-open',
    //         },
    //         {
    //             id: 'reports',
    //             title: 'Reports',
    //             type: 'basic',
    //             icon: 'heroicons_outline:chart-bar',
    //             link: '/reports',
    //         },
    //     ],
    // },
    {
        id: 'certification',
        title: 'Professional Certification',
        type: 'group',
        icon: 'mat_outline:card_membership',
        children: [
            {
                title: 'Certificates',
                id: 'certification',
                link: '/certification',
                type: 'basic',
                icon: 'mat_outline:approval',
            },
            {
                title: 'Schools',
                id: 'school',
                link: '/schools',
                type: 'basic',
                icon: 'mat_outline:school',
            },
            {
                title: 'Classes',
                id: 'class',
                link: '/classes',
                type: 'basic',
                icon: 'mat_outline:class',
            },
        ],
    },
];
